<template>
  <div v-if="fetching || nodata || error" class="statusMessage">
    <div class="nodata" v-if="(nodata || error) && !fetching">
      <img src="@/assets/img/empty-box-open.svg" width="60px" alt="" />
      <div v-if="nodata && !error">No data</div>
      <div v-if="error">Something wrong</div>
    </div>
    <!-- <div class="error" v-if="error">ไม่พบข้อมูล!</div> -->
    <div class="fetching" v-if="fetching">โหลดข้อมูล...</div>
  </div>
</template>

<script>
export default {
  props: { fetching: Boolean, error: Boolean, nodata: Boolean },
  name: "DefaultDisplayStage",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.statusMessage {
  text-align: center;
  // margin: 10px auto 10px auto;
  color: #909090;

  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
}
</style>